import { FormattedMessage, useIntl } from "react-intl";

import { transformChunks } from "shared/components/TextWrapper";
import { YesNoModal, YesNoModalProps } from "shared/components/YesNoModal";

export type DraftListExistsModalOpenProps = Pick<YesNoModalProps, "onClickYes" | "onClickNo">;

export function DraftListExistsModalOpen({ onClickYes, onClickNo }: DraftListExistsModalOpenProps) {
  const intl = useIntl();
  return (
    <YesNoModal
      isOpen
      onClickYes={onClickYes}
      onClickNo={onClickNo}
      title={intl.formatMessage({
        id: "components.draft-list-exists-modal.title",
      })}
      body={
        <FormattedMessage
          id="components.draft-list-exists-modal.body"
          values={transformChunks({ b: { as: "strong" } })}
        />
      }
      yesLabel={intl.formatMessage({
        id: "flows.inbound.page.inbound-shared-list.button.continue",
      })}
      noLabel={intl.formatMessage({
        id: "generic.actions.cancel",
      })}
      isGrey
    />
  );
}
